import { FC } from 'react';
import { IconProps } from '../types';

export const MenuIcon: FC<IconProps> = ({ width = 26, height = 26, ...props }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M4.3335 13.0008H21.6668M4.3335 6H21.6668M4.3335 20H9.2085H14.0835'
        stroke='var(--color-foreground)'
        strokeWidth='1.33'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
